module.exports = __webpack_public_path__ + "img/button_back.e85bf55.png";